// 营业执照选项
export const BusinessLicense = [
  {label: '干线', value: '1'},
  {label: '城配', value: '2'},
  {label: '仓', value: '3'},
]
export const statusKey = {
  'WAIT_AUDIT': 'WAIT_AUDIT',
  'PASS': 'PASS',
  'REJECT': 'REJECT'
}
export const auditStatus = {
  [statusKey.WAIT_AUDIT]: '待审核',
  [statusKey.PASS]: '审核通过',
  [statusKey.REJECT]: '审核失败'
}